module.exports = __webpack_public_path__ + "img/nitori kawashiro_sc1.99797cd5.png";